import { escapeHTML, purify } from "$json/lib/escape.js";
import { label, valueInside } from "$json/lib/form-widgets-definitions.js";
import { registerWidget } from "$json/lib/form-widgets.js";

import { converter } from "$md-converter";

const details = {
  name: "details-summary",
  attribs: label.attribs,
  render: (control, group, attribs) => {
    const lines = control.value.split(/\r?\n/);
    const summary = document.createElement("summary");
    summary.innerHTML = purify(
      converter.makeHtml(escapeHTML(lines.shift()), true)
    );
    const details = valueInside(
      {
        value: ""
      },
      attribs,
      "details"
    );
    const div = document.createElement("section");
    div.innerHTML = purify(
      converter.makeHtml(escapeHTML(lines.join("\n")), false)
    );
    div.classList.add("bb-md-able");
    details.insertAdjacentElement("afterbegin", summary);
    details.insertAdjacentElement("beforeend", div);
    return details;
  }
};

jQuery(document).on("bb-p:control-filter", (ev, control) => {
  if (control.metadata && control.metadata["p-details-summary"]) {
    control.controltype = "details-summary";
  }
});

registerWidget(details);
